module.exports = __webpack_public_path__ + "img/icon2.c551c3d.png";